export const NEWS_TYPES = ["news", "poll", "suggestion"] as const;

export type NewsType = (typeof NEWS_TYPES)[number];

export const NEWS_ID_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export type NewsCatalogItem = {
  id: string;
  type: NewsType;
  publishedAt: string;
};

export function isNewsType(value: string): value is NewsType {
  return (NEWS_TYPES as readonly string[]).includes(value);
}

export function isNewsId(value: string): boolean {
  return NEWS_ID_PATTERN.test(value);
}
